<i18n>
{
  "fr":{
    "Label": "Générer le rapport"
  }
}
</i18n>

<template>
  <button
    :type="type"
    class="btn btn-primary"
    @click="$emit('click')">
    <span class="d-inline-block">{{ computedLabel }}</span>
  </button>
</template>

<script>
import { computed, props } from '.';

export default {
  props,
  computed,
};
</script>
